var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "icon/20/icon-check-circle"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "Output-svg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "out",
    transform: "translate(-797.000000, -29.000000)",
    fill: "#D5D5D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M806.999588,31 C802.581647,31 799,34.5822863 799,39 C799,43.4185376 802.581647,47 806.999588,47 C811.418353,47 815,43.4185376 815,39 C815,34.5822863 811.418353,31 806.999588,31 L806.999588,31 Z M806.542504,41.4981723 C806.265748,41.7672759 805.816641,41.7672759 805.539885,41.4981723 L803.664741,39.6748741 C803.311753,39.3316461 803.311753,38.7757134 803.664741,38.4332911 L803.677999,38.4203999 C804.030158,38.0779775 804.601899,38.0779775 804.954058,38.4212056 L806.041195,39.4790891 L809.046563,36.5568167 C809.399551,36.2143944 809.970464,36.2143944 810.322623,36.5568167 L810.335881,36.5697079 C810.68804,36.9121303 810.68804,37.4672573 810.335881,37.8096796 L806.542504,41.4981723 Z",
    id: "path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleDisabled);
export default __webpack_public_path__ + "static/media/check-circle-disabled.ac48f5e7d0767c7c460d00ce780c2045.svg";
export { ForwardRef as ReactComponent };